<template>
    <div>
        <div class="inner_container content_box withPad ">
            <div v-if="data_api" class="d-flex flex-column justify-space-between align-center">
                <v-img v-if="image" contain max-width="100%" :src="image" :lazy-src="image_lazy" style="border-radius: 15px;">
                    <template v-slot:placeholder>
                        <v-row class="fill-height ma-0" align="center" justify="center">
                            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                        </v-row>
                    </template>
                </v-img>
            </div>
            <div v-if="$parent.data.isRunning" class="button_row text-right button_cover" @click="$router.push({name:nextPage})">
                <v-btn large rounded color="primary" dark>
                    {{ $store.state.layouts.display.cover.button.text }}
                </v-btn>
            </div>
            
            <div v-if="!$parent.data.isRunning">

                <vue-countdown-timer
                    @start_callback="quizStart()"
                    @end_callback="quizEnd()"
                    :start-time="startTime"
                    :end-time="endTime"
                    :interval="1000"
                    :start-label="''"
                    :end-label="'Until end:'"
                    label-position="begin"
                    :end-txt="''"
                    :day-txt="'hari'"
                    :hour-txt="'jam'"
                    :minutes-txt="'menit'"
                    :seconds-txt="'detik'">

                    <template slot="countdown" slot-scope="scope">
                        <div class="rundown text-center mt-3">
                            <h3>Tungguin ya, Kuis akan segera di mulai dalam waktu</h3>
                            <div class="row_countodown">
                                <div class="time_info">
                                    <span>{{scope.props.days}}</span><i>{{scope.props.dayTxt}}</i>
                                </div>
                                <div class="time_info">
                                    <span>{{scope.props.hours}}</span><i>{{scope.props.hourTxt}}</i>
                                </div>
                                <div class="time_info">
                                    <span>{{scope.props.minutes}}</span><i>{{scope.props.minutesTxt}}</i>
                                </div>
                                <div class="time_info">
                                    <span class="hide">{{scope.props.seconds}}</span><i class="hide">{{scope.props.secondsTxt}}</i>
                                </div>
                            </div>
                        </div>
                    </template>

                    <template slot="end-text" slot-scope="scope">
                        <div v-if="caption_exp" class="rundown text-center mt-3" :data-text="scope.props.endText"><h3>{{caption_exp}}</h3></div>
                    </template>
                    
                </vue-countdown-timer>

                <div v-if="$parent.data.unique_message" class="title_cover mt-5">
                    <h3>{{$parent.data.unique_message}}</h3>
                </div>
                
            </div>
            
        </div><!--end.page1-->
    </div>
</template>

<script>
import { getTime, parseISO, addDays } from 'date-fns';

export default {
  name: "cover",
  data() {
    return {
      data_api: this.$parent.data.get,
      //startTime: this.$parent.data.get.schedule_start ? this.$store.getters.moment(this.$parent.data.get.schedule_start).unix() : null,
      //endTime: this.$parent.data.get.schedule_end || this.$store.getters.moment().add(5, 'd').unix(),
      startTime: this.$parent.data.get.schedule_start ? getTime(parseISO(this.$parent.data.get.schedule_start)) : null,
      endTime: this.$parent.data.get.schedule_end || getTime(addDays(new Date(), 5)),
      image: this.$parent.data.get.cover_image ? this.$parent.data.get.cover_image.real : null,
      image_lazy : this.$parent.data.get.cover_image ? this.$parent.data.get.cover_image.real : null,
      image_exp : this.$parent.data.get.image_exp ? this.$parent.data.get.image_exp.real : null,
      caption_exp: this.$parent.data.get.caption_exp ? this.$parent.data.get.caption_exp : 'Maaf, Periode kuis telah berakhir tungguin ya keseruan lainnya di kuis berikutnya',
      nextPage: this.$store.state.layouts.flow[1]!='cover' ? this.$store.state.layouts.flow[1] : 'intro'
    };
  },
  mounted()
  {
        if(this.data_api.type=='tebak_skor'){
            var answer = this.data_api.tebak_skor.answered??null
            if(answer==='1')  this.$router.push({name:'result'})
        }
        if( !this.data_api.cover_image ) this.$router.push({name:this.nextPage})

        //init image
        if( this.$store.state.data.get.schedule_end )
        {
            //if( this.$store.getters.moment(this.$store.state.data.get.schedule_end).unix() < this.$store.getters.moment().unix() )
            if( getTime(parseISO(this.$store.state.data.get.schedule_end)) < getTime(new Date()) )
            {
                //this.image = this.$parent.data.get.result ? this.$parent.data.get.result.real : this.$parent.data.get.cover_image.real;
                //this.image_lazy = this.$parent.data.get.result ? this.$parent.data.get.result.photo : this.$parent.data.get.cover_image.real;
                this.image = this.image_exp??require('../../assets/images/end_periode_quiz.png');
                this.image_lazy = this.image;
            }
        }
  },
  created()
  {
      this.viewTracker('cover');
      this.$parent.updateHead();
  },
  methods:{
      quizStart()
      {
          this.$store.state.data.isRunning = true

          this.$router.push({name:this.nextPage})
      },
      quizEnd()
      {
          this.$store.state.data.isRunning = false
      }
  }
  
};
</script>
